import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-suivi-public',
  templateUrl: './suivi-public.component.html',
  styleUrls: ['./suivi-public.component.scss']
})
export class SuiviPublicComponent {
  numero = '';
  chargement = false;
  erreur: string | null = null;
  commande: any = null;

  /** Étapes alignées sur [StatutLivraison] côté API. */
  private readonly etapes: { code: string; libelle: string }[] = [
    { code: 'EN_ATTENTE', libelle: 'Commande enregistrée' },
    { code: 'EN_PREPARATION', libelle: 'En route vers le retrait' },
    { code: 'AFFECTE', libelle: 'Livreur assigné' },
    { code: 'EN_LIVRAISON', libelle: 'Colis en route' },
    { code: 'LIVRE', libelle: 'Livrée' }
  ];

  constructor(private http: HttpClient) {}

  get etapesAffichage(): { code: string; libelle: string; atteinte: boolean }[] {
    const statut = (this.commande?.statut || this.commande?.status || '').toString().toUpperCase();
    const idx = this.etapes.findIndex(e => e.code === statut);
    const pos = idx >= 0 ? idx : 0;
    return this.etapes.map((e, i) => ({ ...e, atteinte: i <= pos }));
  }

  get referenceCommande(): string {
    const c = this.commande;
    if (!c) return '';
    return (c.numeroCommande || c.numeroSuivi || '').toString();
  }

  rechercher(): void {
    const n = (this.numero || '').trim();
    this.erreur = null;
    this.commande = null;
    if (!n) {
      this.erreur = 'Saisissez votre numéro de commande ou de suivi.';
      return;
    }
    this.chargement = true;
    const url = `${environment.apiurl}commandes/search/suivi/${encodeURIComponent(n)}`;
    this.http.get<any>(url).subscribe({
      next: (data) => {
        this.commande = data;
        this.chargement = false;
      },
      error: (err) => {
        this.chargement = false;
        if (err.status === 404) {
          this.erreur = 'Aucune commande trouvée pour ce numéro.';
        } else {
          this.erreur = 'Impossible de contacter le serveur. Réessayez plus tard.';
        }
      }
    });
  }
}
